export const all = () => {
    return [
        {
            key: "NEW_RESOLUTION",
            value: 1,
        },
        {
            key: "RESOLUTION_SIGN",
            value: 2,
        },
        {
            key: "RESOLUTION_COMMENT",
            value: 3,
        },
        {
            key: "RESOLUTION_ANSWER",
            value: 4,
        },
        {
            key: "IN_PROCESS_REMARKS",
            value: 5,
        },
        {
            key: "ADDITIONAL_AGREEMENT_REMARKS",
            value: 6,
        },
    ]
}

export const getValueByKey = (key) => {
    return all().find(item => item.key === key)?.value
}

export default {
    all,
    getValueByKey,
};